import { Box, Container, Typography } from "@mui/material";
import { useMemo } from "react";

import { useGetPublicLabgramsQuery } from "api/public/labgrams/labgrams.api";
import { PublicLabgram } from "api/public/labgrams/labgrams.types";
import NiapAccordion from "components/MUI/Accordion/NiapAccordion";
import Subheader from "components/Subheader";
import { usePageTitle } from "hooks/usePageTitle";

import LabgramsTable from "./components/LabgramsTable";

interface SortedLabgrams {
  active: PublicLabgram[];
  inactive: PublicLabgram[];
}

const EMPTY_ARRAY: PublicLabgram[] = [];

export default function LabgramsPage() {
  usePageTitle("NIAP - Labgrams");

  const { data: labgrams = EMPTY_ARRAY, isLoading } =
    useGetPublicLabgramsQuery();
  const { active, inactive } = useMemo(() => {
    if (!labgrams) return { active: [], inactive: [] };

    return labgrams.reduce(
      (acc, labgram) => {
        const list = labgram.archived ? "inactive" : "active";
        acc[list].push(labgram);
        return acc;
      },
      { active: [], inactive: [] } as SortedLabgrams,
    );
  }, [labgrams]);

  return (
    <>
      <Subheader pageName={"Labgrams"} />
      <Container maxWidth="md" sx={{ py: 3 }}>
        <Box my={2}>
          <Typography variant="h3">RESOURCES - LABGRAMS</Typography>
          <Typography variant="body1" mt={2}>
            LabGrams are a means of communication between the CCEVS and CCTLs
            (including applicant CCTLs). They are distributed electronically to
            subscribers of the ccevs-labs & ccevs-applicants mail distribution
            lists. LabGrams deliver guidance and CCEVS policy until such time
            that CCEVS publications are updated.
          </Typography>
        </Box>

        <NiapAccordion
          title={`${active.length} CURRENT LABGRAMS`}
          headerProps={{ fontSize: 18 }}
        >
          <LabgramsTable
            title="Active Labgrams"
            rows={active}
            loading={isLoading}
          />
        </NiapAccordion>

        <NiapAccordion
          title={`${inactive.length} SUPERSEDED OR OUTDATED LABGRAMS`}
          headerProps={{ fontSize: 18 }}
          slotProps={{ transition: { unmountOnExit: true } }}
        >
          <LabgramsTable
            title="Inactive Labgrams"
            rows={inactive}
            loading={isLoading}
          />
        </NiapAccordion>
      </Container>
    </>
  );
}
